"use strict";

exports.__esModule = true;

var shared_1 = require("./shared");

var PublicKeyAlgorithmHexCodes;

(function (PublicKeyAlgorithmHexCodes) {
  PublicKeyAlgorithmHexCodes["GOSTR3410_94"] = "2a8503020214";
  PublicKeyAlgorithmHexCodes["GOSTR3410_2001"] = "2a8503020213";
  PublicKeyAlgorithmHexCodes["GOSTR3410_2012_256"] = "2a850307010101";
  PublicKeyAlgorithmHexCodes["GOSTR3410_2012_512"] = "2a850307010102";
})(PublicKeyAlgorithmHexCodes || (PublicKeyAlgorithmHexCodes = {}));
/**
 * Определение алгоритма открытого ключа путем поиска закодированных OID алгоритмов
 * в контенте сертификата.
 * http://rsdn.org/article/ASN/ASN.xml
 * @param hexContent контент сертификата в шестнадцатиричном виде
 */


exports.getPublicKeyAlgorithm = function (hexContent) {
  switch (true) {
    case hexContent.indexOf(PublicKeyAlgorithmHexCodes.GOSTR3410_2001) !== -1:
      {
        return shared_1.PublicKeyAlgorithm.GOSTR410_2001;
      }

    case hexContent.indexOf(PublicKeyAlgorithmHexCodes.GOSTR3410_2012_256) !== -1:
      {
        return shared_1.PublicKeyAlgorithm.GOSTR3410_2012_256;
      }

    case hexContent.indexOf(PublicKeyAlgorithmHexCodes.GOSTR3410_2012_512) !== -1:
      {
        return shared_1.PublicKeyAlgorithm.GOSTR3410_2012_512;
      }

    case hexContent.indexOf(PublicKeyAlgorithmHexCodes.GOSTR3410_94) !== -1:
      {
        return shared_1.PublicKeyAlgorithm.GOSTR3410_94;
      }

    default:
      {
        return;
      }
  }
};

exports.base64ToHex = function (str) {
  var hex = '';
  var bin = window.atob(str.replace(/[ \r\n]+$/, ''));

  for (var i = 0; i < bin.length; i++) {
    var tmp = bin.charCodeAt(i).toString(16);

    if (tmp.length === 1) {
      tmp = '0' + tmp;
    }

    hex += tmp;
  }

  return hex;
};